import React from "react";
import Main from "./component/main/Main";

function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
